import { defineMessages } from 'react-intl';

export default defineMessages({
  azimutForYouLable: {
    id: 'features.newsPage.azimutForYouLable',
    defaultMessage: 'Azimut per te',
    description: 'azimut For You Lable',
  },

  inTheForegroundLabel: {
    id: 'features.newsPage.inTheForegroundLabel',
    defaultMessage: 'In primo piano',
    description: 'in The Foreground Label',
  },

  otherVideoLabel: {
    id: 'features.newsPage.otherVideoLabel',
    defaultMessage: 'Altri video',
    description: 'other Video Label',
  },

  noVideoLabel: {
    id: 'features.newsPage.noVideoLabel',
    defaultMessage: 'Non sono ancora presenti contenuti',
    description: 'No Video Label',
  },
});
